import React from "react";
import useWebsiteConfiguration from "../../../hooks/useWebsiteConfiguration";
import { websiteConfigurationEnum } from "../../../enums/websiteConfigurations/websiteConfigurationType.enum";
import "../../../styles/layouts/footer/_footerContactUsContainer.scss";

const FooterContactUsContainer = () => {
  // Fetch contact details from website configuration
  const contactDetails = useWebsiteConfiguration(websiteConfigurationEnum.ContactDetails);

  if (!contactDetails) return null;

  const { Phone, Email, Address } = contactDetails;

  return (
    <div className="footerContactUsContainer">
      <h2>צרו קשר</h2>
      <ul>
        <li>
          <i className="fa-solid fa-location-dot"></i> {Address}
        </li>
        <li>
          <i className="fa-solid fa-phone"></i> <a href={`tel:${Phone}`}>{Phone}</a>
        </li>
        <li>
          <i className="fa-solid fa-envelope"></i> <a href={`mailto:${Email}`}>{Email}</a>
        </li>
      </ul>
    </div>
  );
};

export default FooterContactUsContainer;
